import mixpanel from 'mixpanel-browser';

type MixpanelEvents = {
  'Online approval web - View Invalid Timesheet Screen': Record<string, never>;
  'Online approval web - View Active Timesheet Screen': {
    Timesheet_ID: string;
    Origination_Source: 'email';
  };
  'Online approval web - Approval Success': {
    Timesheet_ID: string;
    Has_Approver_Email: boolean;
    Signature: 'drawn' | 'typed';
  };
  'Online approval web - Approval Failure': {
    Timesheet_ID: string;
    Has_Approver_Email: boolean;
    Signature: 'drawn' | 'typed';
  };
  'Online approval web - Forward request': {
    Timesheet_ID: string;
    Origination_Source: 'web' | 'email';
  };
  'Online approval web - Forward request success': {
    Timesheet_ID: string;
  };
  'Online approval web - Forward request failure': {
    Timesheet_ID: string;
  };
  'Online approval web - Feature Flag Enabled': {
    Feature_Flag_Name: string;
  };
  'Online approval web - Press Draw Signature tab': {
    Timesheet_ID: string;
  };
  'Online approval web - Press Type Signature tab': {
    Timesheet_ID: string;
  };
  'Online approval web - Press Accept All': {
    Timesheet_ID: string;
  };
  'Online approval web - Press Reject All': {
    Timesheet_ID: string;
  };
  'Online approval web - Press Add Rejection Note': {
    Timesheet_ID: string;
  };
  'Online approval web - Press Accept': {
    Timesheet_ID: string;
  };
  'Online approval web - Press Reject': {
    Timesheet_ID: string;
  };
  'Online approval web - Press Back to timesheet actions link': {
    Timesheet_ID: string;
    Source_Screen: 'Forward approval' | 'Verify timesheet' | 'Approve timesheet';
  };
  'Online approval web - Verified success': {
    Timesheet_ID: string;
    Has_Verifier_Email: boolean;
  };
  'Online approval web - Verified failure': {
    Timesheet_ID: string;
    Has_Verifier_Email: boolean;
  };
  'Online approval web - Delete verification': {
    Timesheet_ID: string;
  };
};

export type MixpanelEventName = keyof MixpanelEvents;

type Analytics = {
  track: <TEventKey extends MixpanelEventName>(eventName: TEventKey, properties?: MixpanelEvents[TEventKey]) => void;
};

export const useAnalytics = (): Analytics => {
  const track = <TEventKey extends MixpanelEventName>(eventName: TEventKey, properties?: MixpanelEvents[TEventKey]) => {
    mixpanel.track(eventName, { ...(properties ?? {}), sourcePlatform: 'Approver_Web' });
  };

  return {
    track,
  };
};
